<div class="camera-calendar-month">
  <div class="camera-calendar-month__header">
    <div class="camera-calendar-month__header-left">
      <button mat-icon-button (click)="onClickBack()" matTooltip="back to year">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h4 class="camera-calendar-month__title">{{ selectedDate() | date: 'yyyy-MM' }}</h4>
    </div>
    <div class="camera-calendar-month__header-right">
      <button mat-icon-button (click)="onClickPrevious()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button (click)="onClickNext()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>
  <div class="camera-calendar-month__wrapper">
    @for (weekday of weekdays; track weekday) {
      <div class="camera-calendar-month__weekday">{{ weekday }}</div>
    }
    @for (i of dayOffset(); track i) {
      <div></div>
    }
    @for (d of days(); track d; let i = $index) {
      <ng-container
        *ngTemplateOutlet="item; context: { label: d, index: i, fixRate: fixesOfDays()?.[i] }"
      ></ng-container>
    }
  </div>
</div>
<ng-template #item let-fixRate="fixRate" let-label="label" let-index="index">
  <span
    class="camera-calendar-month__item"
    [ngClass]="{ active: fixRate.number > 0 }"
    matTooltip="{{ getTooltip(fixRate) }}"
    (click)="onClickItem(index, fixRate.number > 0)"
    [style.--p]="getPercent(fixRate.number) + '%'"
    >{{ label }}</span
  >
</ng-template>

<div class="camera-calendar-month__legend">
  <div class="camera-calendar-month__legend-max"></div>
  <span>Maximum</span>
  <div class="camera-calendar-month__legend-min"></div>
  <span>Minimum</span>
</div>
